import { ListToBeSorted } from "./SortAndFilter.types";
export const withoutSearch = [ListToBeSorted.PricingHistory];
export const withoutSorting = [ListToBeSorted.TransporterReports, ListToBeSorted.SecurePassLogs];
export const withoutPagination = [];
export const sortToUserFriendly = {
    asc: "Ascending",
    desc: "Descending",
};
export const ignoredColumns = {
    [ListToBeSorted.Users]: ["id", "profilePhoto"],
    [ListToBeSorted.Admins]: ["id", "profilePhoto"],
    [ListToBeSorted.Dealers]: ["id"],
    [ListToBeSorted.DealersGroups]: ["id"],
    [ListToBeSorted.NissanDealers]: ["emails", "moreMenu"],
    [ListToBeSorted.NissanColors]: ["moreMenu"],
    [ListToBeSorted.NissanModels]: ["moreMenu"],
    [ListToBeSorted.NissanPrices]: ["moreMenu"],
    [ListToBeSorted.NissanTenderFile]: [],
    [ListToBeSorted.Transporters]: ["id"],
    [ListToBeSorted.AddressBook]: ["dealerName", "id", "dealerId"],
    [ListToBeSorted.DealerShipments]: ["dealerPrice", "pickupAt", "dropoffAt", "vehiclesCount", "ribbon"],
    [ListToBeSorted.AdminShipments]: ["id"],
    [ListToBeSorted.Quotes]: ["location", "dealerPrice", "vehicles"],
    [ListToBeSorted.TransporterShipments]: ["transporterPrice", "pricePerMile", "ribbon"],
    [ListToBeSorted.TransporterLoads]: ["totalVehicles", "actions", "ribbon"],
    [ListToBeSorted.Payments]: ["dealerInvoice", "transporterBill"],
    [ListToBeSorted.PricingHistory]: ["id", "trailerType", "status", "specialConditions"],
    [ListToBeSorted.TransporterReports]: [],
    [ListToBeSorted.SecurePassLogs]: [],
};
export const renamedColumns = {
    fullName: "name",
    securePassMissingContact: "SecurePass™ Needs Info",
};
export const filterName = {
    page: "Page",
    pageSize: "Page Size",
    filter: "Search",
    sorting: "Sorting",
    stateId: "State",
    stateIds: "State",
    city: "City",
    cities: "City",
    firstName: "First Name",
    userName: "User Name",
    lastName: "Last Name",
    verified: "Verified",
    hasTWIC: "Has TWIC",
    hasEModal: "Has EModal",
    deactivated: "Deactivated",
    isActive: "Active",
    flagStatus: "Flag Status",
    active: "Active",
    duplicate: "Duplicate",
    block: "Block",
    missingInfo: "Missing Info",
    dealerId: "Dealer",
    managerId: "Autosled Manager",
    isPublic: "Is Public",
    email: "Email",
    emailConfirmed: "Email Verified",
    emodal: "With EModal",
    isExternal: "Is External",
    isLockedOut: "Is Locked Out",
    notActive: "Not Active",
    organizationUnitId: "Organization Unit",
    phoneNumber: "Phone Number",
    roleId: "Role",
    rating: "Rating",
    companyGroupId: "Entity Group",
    createdAt: "Created At",
    postedAt: "Posted At",
    pickedUpAt: "Picked Up At",
    droppedOffAt: "Dropped Off At",
    pickedUpETA: "Pickup ETA",
    droppedOffETA: "Dropoff ETA",
    shipmentStatus: "Shipment Status",
    incompleteStatus: "Incomplete Status",
    pickupCity: "Pickup City",
    dropOffCity: "DropOff City",
    pickupStateId: "Pickup State",
    dropOffStateId: "DropOff State",
    billStatus: "Transporter Payment Status",
    invoiceStatus: "Dealer Payment Status",
    transporterId: "Transporter",
    specialConditions: "Special Conditions",
    isHardRoute: "Is Hard Route",
    isOnHold: "Is On Hold",
    isProblemRide: "Is Problem Ride",
    isAutosledExpedited: "Is Autosled Expedited",
    requiresTWIC: "Requires TWIC",
    requiresEModal: "Requires EModal",
    requiresLotExit: "Requires Lot Exit",
    isEnclosed: "Is Enclosed",
    isInoperational: "Is Inoperational",
    isDirectBrokerage: "Is Direct Brokerage",
    isVisible: "Is Visible to Transporters",
    vehicleType: "Vehicle Type",
    // SecurePass
    securePassAutoSendType: "Use SecurePass AutoSend",
    securePassMissingContact: "Missing Contact Info",
    securePassValue: "SecurePass™",
    securePassLogType: "SecurePass Log Type",
    shipmentLocked: "Locked",
    nissanVehicleStatus: "Vehicle Status",
    nissanDropShipStatus: "Dropship Status",
};
export const filterValueText = {
    true: "True",
    false: "False",
};
export const sortChildren = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
];
export const statusChildren = [
    { label: "True", value: true, children: [] },
    { label: "False", value: false, children: [] },
];
export const DEFAULT_FILTERS = {
    page: 1,
    pageSize: 10,
    filter: "",
};
export const filtersByTable = {
    [ListToBeSorted.Users]: ["verified", "hasTWIC", "hasEModal", "isActive"],
    [ListToBeSorted.Admins]: ["firstName", "lastName", "isActive"],
    [ListToBeSorted.Dealers]: ["active", "duplicate", "block", "missingInfo", "managerId"],
    [ListToBeSorted.DealersGroups]: [],
    [ListToBeSorted.NissanColors]: [],
    [ListToBeSorted.NissanModels]: [],
    [ListToBeSorted.NissanPrices]: [],
    [ListToBeSorted.NissanTenderFile]: ["nissanVehicleStatus", "nissanDropShipStatus"],
    [ListToBeSorted.NissanDealers]: [],
    [ListToBeSorted.Transporters]: ["stateId", "city", "active", "duplicate", "block", "missingInfo", "rating"],
    [ListToBeSorted.AddressBook]: [
        "stateIds",
        "cities",
        "dealerId",
        "isPublic",
        "securePassAutoSendType",
        "securePassMissingContact",
    ],
    [ListToBeSorted.DealerShipments]: [],
    [ListToBeSorted.AdminShipments]: [
        "companyGroupId",
        "createdAt",
        "postedAt",
        "pickedUpAt",
        "droppedOffAt",
        "pickedUpETA",
        "droppedOffETA",
        "shipmentStatus",
        "incompleteStatus",
        "pickupCity",
        "dropOffCity",
        "pickupStateId",
        "dropOffStateId",
        "isHardRoute",
        "isOnHold",
        "isProblemRide",
        "isAutosledExpedited",
        "requiresTWIC",
        "requiresEModal",
        "requiresLotExit",
        "isEnclosed",
        "isInoperational",
        "isDirectBrokerage",
        "isVisible",
        "managerId",
        "transporterId",
        "securePassValue",
        "shipmentLocked",
    ],
    [ListToBeSorted.Quotes]: [],
    [ListToBeSorted.TransporterShipments]: [],
    [ListToBeSorted.TransporterLoads]: [],
    [ListToBeSorted.Payments]: [
        "transporterId",
        "dealerId",
        "createdAt",
        "postedAt",
        "pickedUpAt",
        "droppedOffAt",
        "pickedUpETA",
        "droppedOffETA",
        "billStatus",
        "invoiceStatus",
    ],
    [ListToBeSorted.PricingHistory]: [
        "shipmentStatus",
        "dealerId",
        "isHardRoute",
        "isProblemRide",
        "isAutosledExpedited",
        "vehicleType",
    ],
    [ListToBeSorted.TransporterReports]: [],
    [ListToBeSorted.SecurePassLogs]: ["securePassLogType"],
};
export const flagStatusNames = {
    1: filterName.active,
    2: filterName.duplicate,
    3: filterName.block,
    4: filterName.missingInfo,
};
export const flagStatusOptions = ["active", "duplicate", "block", "missingInfo"];
export const singleFiltersParent = {
    verified: { parent: "status" },
    hasTWIC: { parent: "status" },
    hasEModal: { parent: "status" },
    deactivated: { parent: "status" },
    isActive: { parent: "status" },
    active: { parent: "flagStatus", value: 1 },
    duplicate: { parent: "flagStatus", value: 2 },
    block: { parent: "flagStatus", value: 3 },
    missingInfo: { parent: "flagStatus", value: 4 },
    shipmentLocked: { parent: "status" },
};
